import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import '../../../css/huerto/modalsFichaCliente.css';
import FunctionGeneral from '../functionsGeneral';

function ModalSimulaciones(props) {
    function setModalCancelacionAnticipadaID(value) {
        props.setcancelacionAnticipadaIDSelect(value);
        props.setModalCancelacionAnticipada(true);
    }

    let _nombre = new FunctionGeneral().capitalizeText(
        props.esCancelacionCliente ? '' : props.vendedor.split(' ')
    );
    _nombre = props.esCancelacionCliente
        ? ''
        : _nombre.split(' ')[1][0] != undefined
        ? _nombre.split(' ')[0][0] + _nombre.split(' ')[1][0]
        : _nombre.split(' ')[0][0];
    var item = [];

    props.dataSimulacion.forEach(element => {
        var fechaCancelacion = [];
        var fechaVencimiento = [];
        try {
            fechaCancelacion = element.FechaCancelacion.split('T')[0];
            fechaCancelacion = fechaCancelacion.split('-');

            fechaVencimiento = element.FechaPrimerVencimiento.split('T')[0];
            fechaVencimiento = fechaVencimiento.split('-');
            item.push(
                <TableRow style={{ height: '50px' }} key={element.Id}>
                    {!props.esCancelacionCliente ? (
                        <TableCell style={{ width: '50px', maxWidth: '50px' }}>
                            <div
                                style={{
                                    backgroundColor: '#64B196',
                                    width: '20px',
                                    height: '20px',
                                    color: 'white',
                                    borderRadius: '50%',
                                    lineHeight: '20px',
                                    fontSize: '10px',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                }}
                            >
                                {_nombre}
                            </div>
                        </TableCell>
                    ) : (
                        ''
                    )}
                    <TableCell
                        style={{
                            width: '100px',
                            maxWidth: '100px',
                            marginLeft: '5px',
                        }}
                    >
                        {new FunctionGeneral().formatFecha(fechaCancelacion)}
                    </TableCell>
                    <TableCell
                        style={{
                            width: '100px',
                            maxWidth: '100px',
                            marginLeft: '5px',
                        }}
                    >
                        {new FunctionGeneral().formatNum(element.TotalIngresar)}
                        €
                    </TableCell>
                    <TableCell
                        style={{
                            width: '100px',
                            maxWidth: '100px',
                            marginLeft: '5px',
                        }}
                    >
                        {new FunctionGeneral().formatFecha(fechaVencimiento)}
                    </TableCell>
                    <TableCell
                        style={{
                            width: '50px',
                            maxWidth: '50px',
                            marginLeft: '5px',
                        }}
                    >
                        <div
                            className="c-icon c-icon--[control-eye] iconHover"
                            style={{ fontSize: '20px' }}
                            onClick={() => {
                                setModalCancelacionAnticipadaID(element.Id);
                            }}
                        ></div>
                    </TableCell>
                </TableRow>
            );
        } catch {}
    });

    return (
        <div className="c-modal" aria-hidden={'false'}>
            <div className="c-modal__overlay js-modal-close"></div>
            <div
                className="c-modal__wrapper modalFichaCliente"
                role="dialog"
                aria-labelledby="foo-bar-baz"
            >
                <header className="c-modal__header">
                    <div className="o-layout__item u-11/12 ">
                        <label className="u-h3 u-ml-xsmall">
                            Simulación de Cancelación anticipada de un contrato
                        </label>
                    </div>

                    <div className="o-layout__item u-1/12">
                        <button
                            onClick={() => props.setmodalSimulacionTodas(false)}
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Close this dialog window."
                        />
                    </div>
                </header>

                <div className="c-modal__content">
                    <div
                        style={{
                            minHeight: '150px',
                            display: 'grid',
                            maxHeight: '560px',
                            overflow: 'auto',
                        }}
                    >
                        <div className="o-layout__item u-1/1">
                            <Table className="tablaProyeccion">
                                <TableHead>
                                    <TableRow>
                                        {!props.esCancelacionCliente ? (
                                            <TableCell
                                                style={{
                                                    width: '50px',
                                                    maxWidth: '50px',
                                                }}
                                            ></TableCell>
                                        ) : (
                                            ''
                                        )}
                                        <TableCell
                                            style={{
                                                width: '100px',
                                                maxWidth: '100px',
                                                marginLeft: '5px',
                                            }}
                                            className="u-text-muted"
                                        >
                                            Cancelación
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                width: '100px',
                                                maxWidth: '100px',
                                                marginLeft: '5px',
                                            }}
                                            className="u-text-muted"
                                        >
                                            A liquidar
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                width: '100px',
                                                maxWidth: '100px',
                                                marginLeft: '5px',
                                            }}
                                            className="u-text-muted"
                                        >
                                            Primer vto. Incl.
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                width: '50px',
                                                maxWidth: '50px',
                                                marginLeft: '5px',
                                            }}
                                        ></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>{item}</TableBody>
                            </Table>
                        </div>
                    </div>

                    <div className="o-layout__item u-1/1">
                        <button
                            className="CancelActividad c-btn--secondary c-btn"
                            style={{
                                width: '140px',
                                height: '40px',
                                marginTop: '65px',
                            }}
                            onClick={() => props.setmodalSimulacionTodas(false)}
                        >
                            CERRAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default withRouter(ModalSimulaciones);
